import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./Component/Home";
import ResourceDetails from "./Component/ResourceDetails";
import AdminDashboard from "./Component/Admin/AdminDashboard/AdminDashboard";
import AdminLayout from "./Component/Admin/AdminLayout";
import ProtectedRoute from "./Component/Admin/ProtectedRoute";


function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/resource" element={<ResourceDetails />} />
        
        {/* Protected Admin Routes with Layout */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          {/* These will render inside the <Outlet /> of AdminLayout */}
          <Route path="dashboard" element={<AdminDashboard />} />
          {/* Add more admin routes here as needed, e.g., <Route path="settings" element={<AdminSettings />} /> */}
        </Route>

      </Routes>
    </BrowserRouter>
  );
}

export default App;
